export var BaseMapName;
(function (BaseMapName) {
    BaseMapName["DoubleGis"] = "2gis";
    BaseMapName["YMapsSchema"] = "yMapsSchema";
    BaseMapName["YMapsHybrid"] = "yMapsHybrid";
    BaseMapName["YMapsEng"] = "yMapsEng";
})(BaseMapName || (BaseMapName = {}));
